import numberToFixed from './numberToFixed'

export default function formatPercentage(value: number) {
  return `${numberToFixed(value, 2).toLocaleString('ru-RU')} %`
}
